import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_app/notifications')({
  component: NotificationsPage,
})

function NotificationsPage(): JSX.Element {
  return <div>Notificaciones — placeholder</div>
}
